export const actionTypes = {
    TOGGLE_MODAL: 'modal/TOGGLE_MODAL',
}

export const toggleModal = payload => ({
    type: actionTypes.TOGGLE_MODAL,
    payload,
})